import React from 'react';
import { Scrollbar } from '../../Scrollbar';
export const TableBodyWrapper = ({ maxHeight, children }) => {
    if (maxHeight) {
        return React.createElement(Scrollbar, { maxHeight: maxHeight }, children);
    }
    return children;
};
